<template>
  <div>
    <Modal
      :title="modal.title"
      :width="modal.width"
      :height="modal.width"
      :onHideModal="onCloseAndRefresh"
      v-show="showModal('options')"
    >
      <ItemRentUpdate
        v-show="modal.component == 'edit'"
        :operational="operational"
        :showListKitOrAccessory="showListKitOrAccessory"
        :origin="kitOrAccessory"
      />
      <div v-show="modal.component == 'statusStock'">
        <b-tabs>
          <b-tab
            title="Resumo"
            v-if="itemSelected.type == 1 || itemSelected.type == 2"
          >
            <TotalizationItemsMoviment :itemSelected="itemSelected" />
          </b-tab>
          <b-tab
            title="Patrimônio"
            v-if="!itemSelected.allowWithoutPatrimony && (itemSelected.type == 1 || itemSelected.type == 2)"
          >
            <PatrimonyMoviment />
          </b-tab>
          <b-tab title="Histórico">
            <HistoryMoviment />
          </b-tab>
        </b-tabs>
      </div>
      <div v-show="modal.component == 'timeLineAvailability'">
        <TimeLineAvailability v-if="itemSelected.type != 3" />
        <i
          class="icon-only-stock fa-solid fa-grid-2-plus"
          v-if="itemSelected.onlyStock"
        ></i>
      </div>
    </Modal>

    <Modal
      title="Aplicar Desconto"
      width="500"
      v-if="showModal('applyDiscount')"
      :onHideModal="onCloseAndRefresh"
    >
      <ApplyDiscount
        :selected="selected"
        :item="itemSelected"
      />
    </Modal>

    <Modal
      title="Recalcular Valor"
      width="500"
      v-if="showModal('recalculateValue')"
      :onHideModal="onCloseAndRefresh"
    >
      <RecalculateValue :selected="selected" />
    </Modal>

    <Modal
      title="Remover item?"
      width="450"
      v-if="showModal('itemRentDelete')"
      :onHideModal="onCloseAndRefresh"
    >
      <RemoveItem
        :item="itemSelected"
        :operational="operational"
      />
    </Modal>

    <Modal
      title="Alterar Grupo"
      width="800"
      v-if="showModal('changeGroup')"
      :onHideModal="onHideChangeGroupModal"
    >
      <GroupSubgroupTransfer
        :selected="selected"
        :selectedPeriod="selectedPeriod"
        :item="itemSelected"
        v-if="showModalGroup"
      />
    </Modal>

    <Modal
      title="Grupo e Subgrupo"
      width="1000"
      v-if="showModal('groupSubgroup')"
    >
      <GroupDraggable
        :operational="operational"
        :items="itemsForDraggable"
        :selectedPeriod="selectedPeriod"
        :onChanged="onHideGroups"
      />
    </Modal>

    <GroupTemplateChoice
      :visible="showTemplateChoice"
      @choose-template="$emit('template-chosen', 'template')"
      @choose-without-group="$emit('template-chosen', 'without-group')"
      @choose-new="$emit('template-chosen', 'new')"
    />

    <GroupTemplateList
      :groups="[]"
      :visible.sync="showGroupTemplateModalLocal"
      v-model="importedTemplateLocal"
      @create-model="$emit('create-template')"
      @edit-model="(item) => $emit('edit-template', item)"
      @input="(item) => $emit('apply-template', item)"
    />

    <Modal
      :title="createTemplateModalTitle"
      width="950"
      v-if="showModal('createTemplateModel')"
      :onHideModal="onCloseTemplateModal"
    >
      <GroupDraggable
        :operational="operational"
        :items="templateEditItems"
        :selectedPeriod="selectedPeriod"
        :templateMode="true"
        :templateEditing="templateEditItem"
      />
    </Modal>
  </div>
</template>

<script>
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";

import ApplyDiscount from "../ApplyDiscount.vue";
import GroupDraggable from "../GroupDraggable.vue";
import GroupSubgroupTransfer from "../GroupSubgroupTransfer.vue";
import GroupTemplateChoice from "../GroupTemplateChoice.vue";
import GroupTemplateList from "../GroupTemplateList.vue";
import ItemRentUpdate from "../ItemRentUpdate.vue";
import RecalculateValue from "../RecalculateValue.vue";
import RemoveItem from "../RemoveItem.vue";
import HistoryMoviment from "../../../stock/history-moviment/HistoryMoviment.vue";
import PatrimonyMoviment from "../../../stock/items-moviment/PatrimonyMoviment.vue";
import TimeLineAvailability from "../../../stock/shared/TimeLineAvailability.vue";
import TotalizationItemsMoviment from "../../../stock/moviment/TotalizationItemsMoviment.vue";

import { mapGetters, mapState } from "vuex";

export default {
  name: "ItemsRentModalSet",
  components: {
    Modal,
    GroupDraggable,
    GroupTemplateChoice,
    GroupTemplateList,
    GroupSubgroupTransfer,
    ItemRentUpdate,
    ApplyDiscount,
    RecalculateValue,
    RemoveItem,
    TotalizationItemsMoviment,
    PatrimonyMoviment,
    HistoryMoviment,
    TimeLineAvailability,
  },
  props: {
    operational: { type: Boolean, default: false },
    modal: {
      type: Object,
      default: () => ({ title: "Modal", width: 500, component: "" }),
    },
    itemSelected: { type: Object, default: () => ({}) },
    showModalGroup: { type: Boolean, default: false },
    showGroupTemplateModal: { type: Boolean, default: false },
    showTemplateChoice: { type: Boolean, default: false },
    templateEditItem: { type: Object, default: null },
    importedTemplate: { type: Object, default: null },
    itemsForDraggable: { type: Array, default: () => [] },
    templateEditItems: { type: Array, default: () => [] },
    selectedPeriod: { type: Object, default: () => ({}) },
    showListKitOrAccessory: { type: Boolean, default: false },
    kitOrAccessory: { type: String, default: "" },
  },
  computed: {
    ...mapState("generic", ["selected"]),
    ...mapGetters("generic", ["showModal"]),
    showGroupTemplateModalLocal: {
      get() {
        return this.showGroupTemplateModal;
      },
      set(value) {
        this.$emit("update:showGroupTemplateModal", value);
      },
    },
    importedTemplateLocal: {
      get() {
        return this.importedTemplate;
      },
      set(value) {
        this.$emit("update:importedTemplate", value);
      },
    },
    createTemplateModalTitle() {
      return this.templateEditItem && this.templateEditItem.id
        ? "Editar Modelo"
        : "Criar Modelo";
    },
  },
  methods: {
    onCloseAndRefresh() {
      this.$emit("modal-closed");
    },
    onHideChangeGroupModal() {
      this.$emit("hide-change-group-modal");
      this.$emit("modal-closed");
    },
    onHideGroups() {
      this.$emit("hide-groups");
    },
    onCloseTemplateModal() {
      this.$emit("close-template-modal");
    },
  },
};
</script>
